/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import {
  ETransportDocumentTypeSelectableResourceService
} from './etransport-document-type-selectable-resource.service';
import {
  ETransportOperationTypeSelectableResourceService
} from './etransport-operation-type-selectable-resource.service';
import { ETransportPtfSelectableResourceService } from './etransport-ptf-selectable-resource.service';
import {
  ETransportCustomsOfficeSelectableResourceService
} from './etransport-customs-office-selectable-resource.service';
import {
  ETransportCombinedNomenclatureSelectableResourceService
} from './etransport-combined-nomenclature-selectable-resource.service';
import {
  ETransportOperationPurposeSelectableResourceService
} from './etransport-operation-purpose-selectable-resource.service';
import {
  ETransportConfirmationTypeSelectableResourceService
} from './e-transport-confirmation-type-selectable-resource.service';

export const etransportSelectableResourceProviders = [
  {
    provide: SelectableResourceService,
    useClass: ETransportDocumentTypeSelectableResourceService,
    multi: true,
  },
  {
    provide: SelectableResourceService,
    useClass: ETransportOperationTypeSelectableResourceService,
    multi: true,
  },
  {
    provide: SelectableResourceService,
    useClass: ETransportPtfSelectableResourceService,
    multi: true,
  },
  {
    provide: SelectableResourceService,
    useClass: ETransportCustomsOfficeSelectableResourceService,
    multi: true,
  },
  {
    provide: SelectableResourceService,
    useClass: ETransportCombinedNomenclatureSelectableResourceService,
    multi: true,
  },
  {
    provide: SelectableResourceService,
    useClass: ETransportOperationPurposeSelectableResourceService,
    multi: true,
  },
  {
    provide: SelectableResourceService,
    useClass: ETransportConfirmationTypeSelectableResourceService,
    multi: true,
  }
];
